import { render } from "./RDEListTable.vue?vue&type=template&id=2c03f835&scoped=true"
import script from "./RDEListTable.vue?vue&type=script&lang=js"
export * from "./RDEListTable.vue?vue&type=script&lang=js"

import "./RDEListTable.vue?vue&type=style&index=0&id=2c03f835&scoped=true&lang=css"

import exportComponent from "/Users/victorbello/Documents/Tizeti/Hotspot/eutelsat_branch/Expresswifi_os/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c03f835"]])

export default __exports__